/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Balance of an account for a specific (implied) runtime and token.
 * @export
 * @interface BareTokenHolder
 */
export interface BareTokenHolder {
    /**
     * The Oasis address of the account holder.
     * @type {string}
     * @memberof BareTokenHolder
     */
    holder_address: string;
    /**
     * The Ethereum address of the same account holder, if meaningfully defined.
     * @type {string}
     * @memberof BareTokenHolder
     */
    eth_holder_address?: string;
    /**
     * Number of tokens held, in base units.
     * @type {string}
     * @memberof BareTokenHolder
     */
    balance: string;
}

export function BareTokenHolderFromJSON(json: any): BareTokenHolder {
    return BareTokenHolderFromJSONTyped(json, false);
}

export function BareTokenHolderFromJSONTyped(json: any, ignoreDiscriminator: boolean): BareTokenHolder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'holder_address': json['holder_address'],
        'eth_holder_address': !exists(json, 'eth_holder_address') ? undefined : json['eth_holder_address'],
        'balance': json['balance'],
    };
}

export function BareTokenHolderToJSON(value?: BareTokenHolder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'holder_address': value.holder_address,
        'eth_holder_address': value.eth_holder_address,
        'balance': value.balance,
    };
}


